module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"exportBuildings":"Alle Liegenschaften exportieren (JSON)"}}')
  delete Component.options._Ctor
}
